import type { AccessGroupSystem } from '../api/types'

/**
 * The dry-run read-only rule: a canonical row bound to a system in dry run
 * is READ-ONLY in the console — edits to an unmanaged binding are
 * overwritten by the next sync, and a managed one can't push, so either way
 * an edit would be a lie. Returns the hint text when the row is bound to at
 * least one dry-run system, undefined when it is editable.
 *
 * Used by every list-row / detail-page destructive action (the pattern
 * introduced on AccessGroupDetail members and the Schedules page).
 */
export function readOnlyReason(obj: { systems?: AccessGroupSystem[] }): string | undefined {
  const dry = (obj.systems ?? []).find((s) => s.dry_run)
  return dry ? `Read-only: ${dry.name} is in dry run` : undefined
}
